var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"tag":"h6","to":_vm.linkDestination,"exact":"","disabled":_vm.status == 'pending',"event":_vm.status == 'pending' ? 'click' : ''}},[_c('div',{staticClass:"action",class:{ 
      'action-pending': _vm.status=='pending'
    }},[_c('div',{staticClass:"action-check",class:{ 
          'action-check-checked': _vm.status=='completed'
        }}),_c('div',{staticClass:"action-text"},[_vm._v(_vm._s(_vm.name))]),_c('div',{staticClass:"action-arrow",class:{ 
          'action-arrow-pending': _vm.status=='pending'
        }})])])}
var staticRenderFns = []

export { render, staticRenderFns }